import NetworkLoader from './NetworkLoader';
import styles from './LoadingState.module.css';

export type LoadingVariant = 'inline' | 'fullPage' | 'overlay' | 'spinner' | 'skeleton';

export interface LoadingStateProps {
  variant?: LoadingVariant;
  label?: string;
  branded?: boolean;
  className?: string;
}

export default function LoadingState({
  variant = 'inline',
  label,
  branded = false,
  className = '',
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return <div className={`${styles.skeleton} ${className}`.trim()} aria-hidden />;
  }

  const wrapClass =
    variant === 'fullPage'
      ? styles.fullPage
      : variant === 'overlay'
        ? styles.overlay
        : styles.inline;

  const indicator =
    branded || variant === 'fullPage' ? (
      <NetworkLoader size={variant === 'fullPage' ? 88 : 64} />
    ) : (
      <div className={styles.spinner} aria-hidden />
    );

  return (
    <div
      className={`${wrapClass} ${className}`.trim()}
      role="status"
      aria-label={label}
      aria-live="polite"
    >
      {indicator}
      {label ? <span>{label}</span> : null}
    </div>
  );
}
